import script from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"
export * from "./HowItWorks.vue?vue&type=script&setup=true&lang=js"

import "./HowItWorks.vue?vue&type=style&index=0&id=777e8400&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777e8400"]])

export default __exports__